export const RECEIVE_DRUMS = 'dashboard/DrumManagement/RECEIVE_DRUMS'
export const RECEIVE_CURRENT_DRUM = 'dashboard/DrumManagement/RECEIVE_CURRENT_DRUM'
export const DELETE_DRUM = 'dashboard/DrumManagement/DELETE_DRUM'
export const SET_QUERY_FILTER = 'dashboard/DrumManagement/SET_QUERY_FILTER'
export const SET_PAGING = 'dashboard/DrumManagement/SET_PAGING'
export const SET_UPLOADING_IN_PROGRESS = 'dashboard/DrumManagement/SET_UPLOADING_IN_PROGRESS'
